import React, { memo, useLayoutEffect, useState } from 'react'
import classNames from 'classnames'

import { useHybridFocusable } from '../../hooks/useHybridFocusable'

import playLogo from '../../assets/img/epg_play_logo.svg'

import type { ChannelProps } from './types'
import type {
  FocusDetails,
  FocusableComponentLayout,
} from '@noriginmedia/norigin-spatial-navigation'
import { useNavigationMode } from '../../../../shared/providers/NavigationModeProvider/NavigationModeProvider'

const Channel = ({
  data,
  index,
  onFocus,
  onHover,
  onEnterPress,
  hasHiddenListingAtStart,
  hasFocusedChild,
}: ChannelProps) => {
  const [wasFocused, setWasFocused] = useState(false)
  const { ref, focused, isHovered } = useHybridFocusable({
    onFocus,
    onHover,
    onEnterPress,
    extraProps: { index, channel: data, focusedOnListingsGrid: false },
    focusKey: data.feed_cid,
  })

  const { isCursorMode } = useNavigationMode()

  useLayoutEffect(() => {
    if (!wasFocused && !focused && hasFocusedChild) {
      const handler = isCursorMode ? onHover : onFocus
      handler(
        {} as MouseEvent & FocusableComponentLayout,
        { index, channel: data, focusedOnListingsGrid: true },
        {} as FocusDetails
      )
    }
    setWasFocused(focused)
  }, [focused, hasFocusedChild])

  return (
    <div
      className={classNames('epg__channel', {
        'epg__channel--focused': hasFocusedChild || focused,
        'epg__channel--with-hidden-listing-at-start': hasHiddenListingAtStart,
      })}
      ref={ref}
    >
      <div
        className={classNames('epg__channel-overlay', {
          'epg__channel-overlay--focused': focused,
          'epg__channel-overlay--hovered': isHovered,
        })}
        style={{ visibility: focused || isHovered ? 'visible' : 'hidden' }}
      >
        <p>
          <span>
            <img className="epg__play-focused-logo" src={playLogo} />
          </span>
          <span>Watch Channel</span>
        </p>
      </div>
      <div className="epg__channel-image-container">
        {data?.feed_image?.white_logo ? (
          <img
            className="epg__channel-image"
            src={`${data.feed_image.white_logo}?format=webp&resize=250x56`}
            alt={data.full_name}
          />
        ) : (
          <div className="epg__channel-logo-content">
            <p className="epg__channel-logo-content--text">{data?.full_name}</p>
          </div>
        )}
      </div>
    </div>
  )
}

export default memo(Channel)
